var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9943 12L25.7243 2.09535C26.0919 1.75605 26.0919 1.2074 25.7243 0.868101L25.0596 0.254474C24.692 -0.0848248 24.0976 -0.0848248 23.73 0.254474L13 10.1591L2.26997 0.261694C1.90239 -0.0776057 1.30802 -0.0776057 0.940442 0.261694L0.275681 0.87532C-0.0918935 1.21462 -0.0918935 1.76327 0.275681 2.10257L11.0057 12L0.283501 21.9046C-0.0840728 22.2439 -0.0840728 22.7926 0.283501 23.1319L0.948263 23.7455C1.31584 24.0848 1.91021 24.0848 2.27779 23.7455L13 13.8409L23.73 23.7455C24.0976 24.0848 24.692 24.0848 25.0596 23.7455L25.7243 23.1319C26.0919 22.7926 26.0919 22.2439 25.7243 21.9046L14.9943 12Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0f879e4aa2446a3807afd5c51f9e85db.svg";
export { ForwardRef as ReactComponent };